module.exports = __webpack_public_path__ + "static/assets/6029b21a56fc9277a2e3f14ff759ba7b.png";